import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntLabeledFieldBoxComponent} from "./int-labeled-field-box.component";
import {IntFieldBoxModule} from "../field";

@NgModule({
  imports: [
    CommonModule,
    IntFieldBoxModule
  ],
  declarations: [
    IntLabeledFieldBoxComponent
  ],
  exports: [
    IntLabeledFieldBoxComponent
  ]
})
export class IntLabeledFieldBoxModule {}
